import React, { useEffect, ReactNode } from 'react';
import { useAuth } from './useAuth';
import { configureApi } from './api';

interface Props {
  children: ReactNode;
}

/**
 * Component that connects the API layer with authentication.
 * Must be rendered inside the AuthProvider.
 *
 * Sets up the API interceptor with the token refresh function.
 * Note: Token refresh is done via cookie exchange, not using a refresh token.
 */
export const AuthApiProvider: React.FC<Props> = ({ children }) => {
  const { refreshAccessToken } = useAuth();

  // Configure API with access token refresh capability (via cookie exchange)
  useEffect(() => {
    configureApi(refreshAccessToken);
  }, [refreshAccessToken]);

  return <>{children}</>;
};
